module.exports = __webpack_public_path__ + "img/playicon.1d9ce59d.png";